const MOBILE_PRODUCT_SEARCH_SITE_IDS: number[] = [2];

export default MOBILE_PRODUCT_SEARCH_SITE_IDS;
